import { Fragment, useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Check } from "react-bootstrap-icons";
import { useParams, useSearchParams } from "react-router-dom";
import Swal from "sweetalert2";
import PrintLink from "../../../components/Shipment/Factor/PrintLink.jsx";
import { getRequestByAuth } from "../../../function/helper";
import Footer from "../../../modules/public/footer/footer";
import Loading from "../../../modules/public/loading/loading";
import Menu from "../../../modules/public/menu/menu.jsx";
import "./payResultStyle.css";
import SuccessShipmentBox from "./SuccessShipmentBox.jsx";

function Successful() {
  const params = useParams();

  const [searchParams, setSearchParams] = useSearchParams();
  const [isLoading, setIsLoading] = useState(true);
  const [items, setItems] = useState([]);
  const [erros, setErrors] = useState([]);
  const [totalPrice, settotalPrice] = useState(0);

  const getFactor = async () => {
    setIsLoading(true);
    const response = await getRequestByAuth(
      `/totalpost/v1/detail/${params.id}`
    );
    setIsLoading(false);

    if (response && response.status === 200) {
      setItems(response.data);
      setErrors(response.errors);
      settotalPrice(response.totalPrice);
      return;
    }

    Swal.fire({
      icon: "error",
      text: response.message,
      confirmButtonText: "متوجه شدم",
      confirmButtonColor: "red",
    });
  };

  useEffect(() => {
    if (searchParams.get("errors")) {
      Swal.fire({
        icon: "warning",
        title:
          "در پرداخت " +
          searchParams.get("errors") +
          " مرسوله با خطا مواجه شدیم",
        confirmButtonText: "متوجه شدم",
      }).then(() =>
        setSearchParams(cur => {
          cur.delete("errors");
          return cur;
        })
      );
    }

    window.sessionStorage.clear();
    getFactor();
  }, []);

  if (isLoading) return <Loading />;

  return (
    <Fragment>
      <Menu />
      <Container>
        <Row className="d-flex align-items-center justify-content-center bg-white mt-5 rtl-all">
          <Col
            xl={6}
            lg={6}
            md={6}
            sm={12}
            className="d-flex align-items-center justify-content-center clmn-style"
          >
            <div className="border border-secondary rounded-circle d-flex align-items-center justify-content-center">
              <Check color="green" size={80} />
            </div>
            <h3 className="fs-1 mt-3 text-success">
              پرداخت با موفقیت انجام شد
            </h3>
            <p>
              <span className="fs-2 fw-bold">
                {totalPrice.toLocaleString()}
              </span>
              <small style={{ fontSize: 16 }}> ریال</small>
            </p>
          </Col>

          <div className="text-center mb-4">
            <PrintLink
              className="my-2 p-1 fw-bold btn-success-style px-2 text-center"
              ids={items.map(item => item.id)}
            >
              پرینت فاکتور
            </PrintLink>
          </div>

          {erros.length > 0 && (
            <div className="text-danger">
              <h4>خطا:</h4>
              <p>
                <span> متاسفانه در پرداخت برای سفارش های با شماره</span>
                {erros.map((item, idx) => (
                  <Fragment key={idx}>
                    {idx > 0 && <span> و </span>}
                    <span className="mx-1 fs-4 fw-bold">{item}</span>
                  </Fragment>
                ))}
                <span> با خطا مواجه شدیم</span>
              </p>
            </div>
          )}

          <Row className="my-5 justify-content-around">
            {items.map(item => (
              <SuccessShipmentBox key={item.id} shipment={item} />
            ))}
          </Row>
        </Row>
      </Container>
      <Footer />
    </Fragment>
  );
}

export default Successful;
